import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Container>
        <Row style={{ justifyContent: "center", padding: "20px 0" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "20px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.3em", paddingBottom: "30px", fontWeight: "500" }}>
              About <strong className="purple">Kevin</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "80px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>

        <h1 className="project-heading" style={{ marginTop: "60px" }}>
          Professional <strong className="purple">Skills</strong>
        </h1>

        <Techstack />

        <h1 className="project-heading" style={{ marginTop: "60px" }}>
          <strong className="purple">Tools</strong> I Use
        </h1>
        <Toolstack />

        <h1 className="project-heading" style={{ marginTop: "60px" }}>
          Github <strong className="purple">Stats</strong>
        </h1>
        <Github />
      </Container>
    </Container>
  );
}

export default About;
